import { createContext } from 'react';

export type DragOverParams = {
  isDragOver: boolean;
  isRootDragOver: boolean;
  setIsDragOver(v: boolean): void;
  setIsRootDragOver(v: boolean): void;
};

export const DragDropContext = createContext({} as DragOverParams);

export const DragOverProvider = DragDropContext.Provider;
